<div class="modal-overlay" (click)="fecharModal()">
  <div class="box-nova-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-check-circle"></i> Confirmar Pagamento
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-12" *ngIf="pagamento.conta">
        <p><strong>Conta:</strong> {{ pagamento.conta.descricao }}</p>
      </div>

      <div class="col-md-6">
        <label for="valorPagamento" class="form-label">Valor</label>
        <input type="text" class="form-control" name="valorPagamento" id="valorPagamento" [(ngModel)]="pagamento.valor"
               mask="separator.2" prefix="R$ " thousandSeparator="." decimalMarker="," [dropSpecialCharacters]="true">
      </div>

      <div class="col-md-6">
        <label for="dataPagamento" class="form-label">Data de Pagamento</label>
        <input type="date" class="form-control" name="dataPagamento" id="dataPagamento" [(ngModel)]="pagamento.dataPagamento">
      </div>

      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-light" (click)="fecharModal()">Cancelar</button>
        <button type="button" class="btn btn-success px-4 d-flex align-items-center gap-2" (click)="confirmarPagamento()">
          Confirmar Pagamento
        </button>
      </div>
    </div>
  </div>
</div>
